module.exports = __webpack_public_path__ + "static/media/accomodation.08816c0a.svg";